import request from '@/utils/request'

// 分页查询中介记录信息
export function getPageList(params) {
  return request({
    url: '/hrApi/agencyRecord',
    method: 'get',
    params: params
  })
}

// 获取中介记录列表
export function getList(params) {
  return request({
    url: '/hrApi/agencyRecord/list',
    method: 'get',
    params: params
  })
}

// 新增或编辑中介记录
export function saveOrUpdateData(data) {
  return request({
    url: '/hrApi/agencyRecord',
    method: 'post',
    data: data
  })
}

// 删除中介记录
export function deleteData(id) {
  return request({
    url: '/hrApi/agencyRecord/' + id,
    method: 'delete'
  })
}



// WEBPACK FOOTER //
// ./src/api/agencyRecord.js